import { z } from "zod";
import { onPremisePayLaterPaymentCancellationZodObject } from "./on-premise-pay-later-payment-cancellation";
import { payRequestPaymentCancellationZodObject } from "./pay-request-payment-cancellation";

const paymentCancellationZodUnion = z.union([
    onPremisePayLaterPaymentCancellationZodObject,
    payRequestPaymentCancellationZodObject,
]);
type PaymentCancellation = z.infer<typeof paymentCancellationZodUnion>;

export { paymentCancellationZodUnion };
export type { PaymentCancellation };
